import { IconDefinition } from "./types";

/**
 * @deprecated Use `arrowLeft` instead. This icon will be removed in a future version.
 */
const leftArrow: IconDefinition = {
  iconName: "left-arrow",
  width: 448,
  height: 512,
  svgPathData:
    "M18.2 273l-17-17 17-17L171.8 85.4l17-17 33.9 33.9-17 17L93.1 232 424 232l24 0 0 48-24 0L93.1 280 205.8 392.6l17 17-33.9 33.9-17-17L18.2 273z",
  iconType: "fill",
  unicode: 0xf060,
};

export { leftArrow };
